import { Navigate, useLocation } from 'react-router-dom'
import { loginUrl } from '@/lib/auth-navigation'
import { useAuth } from '@/contexts/AuthContext'
import { ReactNode } from 'react'

interface ProtectedRouteProps {
  children: ReactNode
  requiredPermission?: string
  requiredRole?: string
}

export function ProtectedRoute({ 
  children, 
  requiredPermission,
  requiredRole 
}: ProtectedRouteProps) {
  const { user, isLoading, isAuthenticated } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary-600 border-t-transparent"></div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to={loginUrl(location.pathname + location.search)} replace />
  }

  // Check permission if required
  if (requiredPermission && user) {
    const hasPermission = user.permissions.some(p => 
      p === '*' || 
      p === requiredPermission || 
      p.endsWith('*') && requiredPermission.startsWith(p.replace('*', ''))
    )
    
    if (!hasPermission) {
      return (
        <div className="flex h-screen items-center justify-center">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-gray-900">403</h1>
            <p className="mt-2 text-gray-600">Sem permissão para aceder a esta página</p>
          </div>
        </div>
      )
    }
  }

  // Check role if required
  if (requiredRole && user) {
    const hasRole = user.roles.some(r => r.name === requiredRole)
    
    if (!hasRole) {
      return (
        <div className="flex h-screen items-center justify-center">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-gray-900">403</h1>
            <p className="mt-2 text-gray-600">Sem permissão para aceder a esta página</p>
          </div>
        </div>
      )
    }
  }

  return <>{children}</>
}
